import React, { useState } from "react";
import { Button, Form, Modal, message } from "antd";
import { useMutation } from "react-query";
import { AxiosEmployeeAPI } from "../Api";
import moment from "moment";
import AddEmployeeForm from "../AddEmployeeForm";
import _ from "lodash";
import { createEmployeeErrorLogs } from "../utils";
import { Trans } from "common/components/MockedTrans.tsx";

const useTranslation = () => {
  return { t: (text) => text };
};

export const AddEmployeeModal = ({ reload }) => {
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const mutation = useMutation(
    ["createCompleteEmployee"],
    AxiosEmployeeAPI.createCompleteEmployee,
    {
      onError: (err) => createEmployeeErrorLogs(err),
      onSuccess: () => onSuccess(),
    },
  );

  const onSuccess = () => {
    form.resetFields();
    reload();
    setIsModalOpen(false);
    message.success(t("Funcionário criado com sucesso!"));
  };

  const createEmployee = (values) => {
    mutation.mutate({
      ...values,
      systems_permissions: _(values.systems_permissions)
        .pickBy()
        .keys()
        .value(),
      start_date: moment(values.start_date).format("YYYY-MM-DD"),
    });
  };

  return (
    <>
      <Button
        type="primary"
        onClick={() => setIsModalOpen(true)}
        style={{ marginRight: 20 }}
      >
        <Trans>+ Adicionar funcionário</Trans>
      </Button>
      <Modal
        title={t("Adicionar funcionário")}
        open={isModalOpen}
        onCancel={() => {
          form.resetFields();
          setIsModalOpen(false);
        }}
        width={"40vw"}
        onOk={() => {
          form.validateFields().then((values) => {
            createEmployee(values);
          });
        }}
        okText={t("Confirmar")}
        okButtonProps={{ loading: mutation.isLoading }}
        cancelText={t("Cancelar")}
        centered
      >
        <AddEmployeeForm onFinish={createEmployee} form={form} />
      </Modal>
    </>
  );
};
